module.exports = __webpack_public_path__ + "img/3.10c3b17e.jpg";